import React from 'react';
import './Heading.css';

import { FaLeaf } from 'react-icons/fa';

 

const Heading = ({ title, subTitle = '', sideHeading = false, linear = false }) => {
  return (
    <div className={`heading ${sideHeading ? 'sideheading' : ''} ${linear ? 'linear-bg' : ''}`}>
      
      {/* Render the subTitle section only if subTitle is provided */}
      {subTitle && (
        <div className="sub">
          {!sideHeading && <FaLeaf className="icon" />} {/* Left icon (only when not sideHeading) */}
          <span>{subTitle}</span>
          <FaLeaf className="icon" /> {/* Always show right icon */}
        </div>
      )}

      <h2>{title}</h2>
    </div>
  );
};

export default Heading;